import axios from "axios";

export const FOOTER_REQUEST = "FOOTER_REQUEST";
export const FOOTER_SUCCESS = "FOOTER_SUCCESS";
export const FOOTER_FAIL = "FOOTER_FAIL";

export const fetchRestaurantFooter = (restaurantSlug) => async (dispatch) => {
  dispatch({ type: FOOTER_REQUEST });
  try {
    const response = await axios.get(
      `/api/restaurants/${encodeURIComponent(restaurantSlug)}/footer/`
    );
    dispatch({ type: FOOTER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.detail || error.message || "Failed to load footer";
    dispatch({ type: FOOTER_FAIL, payload: message });
    throw error;
  }
};